import React from 'react';
import { cn } from '@/lib/utils';

const STATUS_TONE = {
  // Requests
  Submitted: 'bg-info/10 text-info border-info/20',
  'For Review': 'bg-warning/10 text-warning border-warning/30',
  'Incomplete Requirements': 'bg-warning/15 text-warning border-warning/30',
  Approved: 'bg-success/10 text-success border-success/30',
  'Ready for Pickup': 'bg-accent/10 text-accent border-accent/30',
  Released: 'bg-success/15 text-success border-success/30',
  Rejected: 'bg-destructive/10 text-destructive border-destructive/30',
  Cancelled: 'bg-muted text-muted-foreground border-border',

  // Concerns
  'For Verification': 'bg-warning/10 text-warning border-warning/30',
  'For Action': 'bg-info/10 text-info border-info/20',
  'In Progress': 'bg-accent/10 text-accent border-accent/30',
  Resolved: 'bg-success/10 text-success border-success/30',
  Closed: 'bg-muted text-muted-foreground border-border',
  Referred: 'bg-info/10 text-info border-info/20',
  'Invalid / Duplicate': 'bg-destructive/10 text-destructive border-destructive/30',

  // Projects
  Completed: 'bg-success/10 text-success border-success/30',
  Ongoing: 'bg-accent/10 text-accent border-accent/30',
  Planned: 'bg-info/10 text-info border-info/20',

  // Urgency
  Urgent: 'bg-destructive/10 text-destructive border-destructive/30',
  Normal: 'bg-muted text-muted-foreground border-border',
};

export const StatusBadge = ({ status, className }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide',
      STATUS_TONE[status] || 'bg-secondary text-secondary-foreground border-border',
      className,
    )}
    data-testid={`status-badge-${status?.replace(/\s|\//g, '-').toLowerCase()}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current opacity-75" />
    {status}
  </span>
);
